export default function DemoController(
  $timeout,

  loaderService,
  ssDialogService,
  editDemoDialog,
  demoSettingsDialog
) {
  const vm = this;

  vm.handleClearFilters = _handleClearFilters;
  vm.handleShowAddDemoClick = _handleShowAddDemoClick;
  vm.handleShowSettingsClick = _handleShowSettingsClick;

  _activate();

  function _activate() {
    vm.appIsLoaded = false;

    _clearFilters();
    _initListItems();

    $timeout(
      () => {
        vm.appIsLoaded = true;
      },
      1000
    );
  }

  function _handleClearFilters() {
    _clearFilters();
  }

  function _handleShowAddDemoClick($event) {
    loaderService.showViewLoader = true;
    const demo = {
      demoRadio1Items: [
        {
          name: 'Some Selection',
          id: 1,
        },
        {
          name: 'Other Selection',
          id: 2,
        },
        {
          name: 'Different Selection',
          id: 3,
        },
        {
          name: 'Last Selection',
          id: 4,
        },
      ],
      demoRadio2Items: [
        {
          name: 'Some Selection',
          id: 1,
        },
        {
          name: 'Other Selection',
          id: 2,
        },
        {
          name: 'Different Selection',
          id: 3,
        },
        {
          name: 'Last Selection',
          id: 4,
        },
      ],
      demoRadio3Items: [
        {
          name: 'Some Selection',
          id: 1,
        },
        {
          name: 'Other Selection',
          id: 2,
        },
        {
          name: 'Different Selection',
          id: 3,
        },
        {
          name: 'Last Selection',
          id: 4,
        },
      ],
      demoRadio4Items: [
        {
          name: 'Some Selection',
          id: 1,
        },
        {
          name: 'Other Selection',
          id: 2,
        },
        {
          name: 'Different Selection',
          id: 3,
        },
        {
          name: 'Last Selection',
          id: 4,
        },
      ],
      demoItems: [
        {
          name: 'List Item 1',
          associate: 'Jeff Giesler',
          date: '12/12/20',
          count: 5,
          info: 'This is some info',
          status: 'Terrible',
        },
        {
          name: 'List Item 2',
          associate: null,
          date: null,
          count: 0,
          info: 'This is some more info',
          status: 'Great',
        },
        {
          name: 'List Item 3',
          associate: 'John Rittelmeyer',
          date: '11/11/20',
          count: 8,
          info: null,
          status: 'Good',
        },
      ],
      selection1Items: [
        {
          selection1ItemId: 1,
          name: 'An Option',
        },
        {
          selection1ItemId: 2,
          name: 'Another Option',
        },
        {
          selection1ItemId: 3,
          name: 'A Different Option',
        },
        {
          selection1ItemId: 4,
          name: 'Yet Another Option',
        },
        {
          selection1ItemId: 5,
          name: 'And Another Option',
        },
        {
          selection1ItemId: 6,
          name: 'The Last Option',
        },
      ],
      selection2Items: [
        {
          selection1ItemId: 1,
          name: 'An Option',
        },
        {
          selection1ItemId: 2,
          name: 'Another Option',
        },
        {
          selection1ItemId: 3,
          name: 'A Different Option',
        },
        {
          selection1ItemId: 4,
          name: 'Yet Another Option',
        },
        {
          selection1ItemId: 5,
          name: 'And Another Option',
        },
        {
          selection1ItemId: 6,
          name: 'The Last Option',
        },
      ],
      selection3Items: [
        {
          selection1ItemId: 1,
          name: 'An Option',
        },
        {
          selection1ItemId: 2,
          name: 'Another Option',
        },
        {
          selection1ItemId: 3,
          name: 'A Different Option',
        },
        {
          selection1ItemId: 4,
          name: 'Yet Another Option',
        },
        {
          selection1ItemId: 5,
          name: 'And Another Option',
        },
        {
          selection1ItemId: 6,
          name: 'The Last Option',
        },
      ],
      tabs: [
        {
          name: 'Tab 1',
          status: 'pending',
          completedCount: 1,
          totalCount: 5,
        },
        {
          name: 'Tab 2',
          status: 'neutral',
          completedCount: 0,
          totalCount: 3,
        },
        {
          name: 'Tab 3',
          status: 'good',
          completedCount: 5,
          totalCount: 5,
        },
        {
          name: 'Tab 4',
          status: 'good',
          completedCount: 3,
          totalCount: 3,
        },
      ],
    };
    ssDialogService.dialogs.demo.editDemoDialog = ssDialogService.alert(
      editDemoDialog.getOptions($event, {
        demo,
      })
    );
    loaderService.showViewLoader = false;
    ssDialogService.show(ssDialogService.dialogs.demo.editDemoDialog);
  }

  function _handleShowSettingsClick($event) {
    loaderService.showViewLoader = true;
    // Timeout used to mimic API call to fetch settings
    $timeout(
      () => {
        const settings = {
          demoRadio1Items: [
            {
              name: 'Some Selection',
              id: 1,
            },
            {
              name: 'Other Selection',
              id: 2,
            },
            {
              name: 'Different Selection',
              id: 3,
            },
            {
              name: 'Last Selection',
              id: 4,
            },
          ],
          demoRadio2Items: [
            {
              name: 'Some Selection',
              id: 1,
            },
            {
              name: 'Other Selection',
              id: 2,
            },
            {
              name: 'Different Selection',
              id: 3,
            },
            {
              name: 'Last Selection',
              id: 4,
            },
          ],
          demoRadio3Items: [
            {
              name: 'Some Selection',
              id: 1,
            },
            {
              name: 'Other Selection',
              id: 2,
            },
            {
              name: 'Different Selection',
              id: 3,
            },
            {
              name: 'Last Selection',
              id: 4,
            },
          ],
          demoRadio4Items: [
            {
              name: 'Some Selection',
              id: 1,
            },
            {
              name: 'Other Selection',
              id: 2,
            },
            {
              name: 'Different Selection',
              id: 3,
            },
            {
              name: 'Last Selection',
              id: 4,
            },
          ],
        };
        loaderService.showViewLoader = false;
        showSettingsDialog($event, { settings });
      },
      1000
    );
  }

  function showSettingsDialog($event, locals) {
    ssDialogService.dialogs.demo.settingsDialog = ssDialogService.alert(
      demoSettingsDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.demo.settingsDialog);
  }

  function _clearFilters() {
    vm.filters = {
      searchText: '',
      quickFilter: true,
      moreFiltersNone: true,
      moreFiltersLow: true,
      moreFiltersMedium: true,
      moreFiltersHigh: true,
    };
  }

  function _initListItems() {
    vm.listItems = [
      {
        name: 'List Item 1',
        associate: 'Jeff Giesler',
        date: null,
        count: 5,
        info: 'This is some info',
        status: 'Terrible',
        reminderCount: 4,
        alertCount: 1,
        listItems: [
          {
            name: 'Inner List Item 1',
            associate: null,
            date: '12/12/20',
            count: 10,
            info: 'This is also some info',
            status: 'Good',
            showList: true,
            listItems: [
              {
                name: 'Sub Inner List Item 1',
                associate: null,
                date: '12/12/20',
                count: 10,
                info: 'This is also some info',
                status: 'Great',
                showList: true,
                listItems: [
                  {
                    name: 'Inner Sub Inner List Item 1',
                    associate: null,
                    date: '12/12/20',
                    count: 10,
                    info: 'This is also some info',
                    status: 'Great',
                    showList: true,
                    listItems: [
                      {
                        name: 'Sub Inner Sub Inner List Item 1',
                        associate: null,
                        date: '12/12/20',
                        count: 10,
                        info: 'This is also some info',
                        status: 'Great',
                        showList: true,
                        listItems: [
                          {
                            name: 'Inner Sub Inner Sub Inner List Item 1',
                            associate: null,
                            date: '12/12/20',
                            count: 10,
                            info: 'This is also some info',
                            status: 'Great',
                            showList: false,
                          },
                          {
                            name: 'Inner Sub Inner Sub Inner List Item 2',
                            associate: 'John Rittelmeyer',
                            date: '09/18/86',
                            count: 4,
                            info: null,
                            status: 'Terrible',
                            showList: false,
                          },
                        ],
                      },
                      {
                        name: 'Sub Inner Sub Inner List Item 2',
                        associate: 'John Rittelmeyer',
                        date: '09/18/86',
                        count: 4,
                        info: null,
                        status: 'Terrible',
                        showList: false,
                      },
                    ],
                  },
                  {
                    name: 'Inner Sub Inner List Item 2',
                    associate: 'John Rittelmeyer',
                    date: '09/18/86',
                    count: 4,
                    info: null,
                    status: 'Terrible',
                    showList: false,
                  },
                ],
              },
              {
                name: 'Sub Inner List Item 2',
                associate: 'John Rittelmeyer',
                date: '09/18/86',
                count: 4,
                info: null,
                status: 'Terrible',
                showList: false,
              },
            ],
          },
          {
            name: 'Inner List Item 2',
            associate: 'John Rittelmeyer',
            date: '09/18/86',
            count: 4,
            info: null,
            status: 'Bad',
            showList: false,
          },
        ],
        showList: true,
      },
      {
        name: 'List Item 2',
        associate: null,
        date: '12/12/20',
        count: 2,
        info: 'This is also some info',
        status: 'Great',
        reminderCount: 2,
        alertCount: 0,
        showList: false,
      },
      {
        name: 'List Item 3',
        associate: 'John Rittelmeyer',
        date: '09/18/86',
        count: 0,
        info: null,
        status: 'Caution',
        reminderCount: 3,
        alertCount: 2,
        showList: true,
      },
    ];
  }
}

DemoController.$inject = [
  '$timeout',

  'loaderService',
  'ssDialogService',
  'editDemoDialog',
  'demoSettingsDialog',
];
